module.exports = __webpack_public_path__ + "img/q_12_sor.eb3f4aad.png";